import { useLocation } from 'react-router-dom'
import WrapperPageSimple from '../../WrapperPage/present/WrapperPageSimple'
import TmdbLinkForm from './TmdbLinkForm'
import RequestOverlayContainer from '../../overlay/container/RequestOverlayContainer'
import getRedirectPath from '../../../functions/getRedirectPath'

const PageTmdbLinkPage = (props) => {
    const location = useLocation()
    const searchParams = new URLSearchParams(location.search)
    const from = searchParams.get('from')

    const backPath = getRedirectPath(from)

    const { onMatch, onUnmatch, ...rest } = props

    const handleMatch = (metaMoviePk, tmdbMoviePk, metaMovie, pmMovie, tmdbMovieData) =>
        onMatch(metaMoviePk, tmdbMoviePk, metaMovie, from, pmMovie, tmdbMovieData)

    const handleUnmatch = (metaMoviePk) =>
        onUnmatch(metaMoviePk, from)

    return (
        <WrapperPageSimple pageTitleTransId="link_tmdb_button" closePagePath={backPath} overlay={<RequestOverlayContainer />}>
            <TmdbLinkForm
                {...rest}
                onMatch={handleMatch}
                onUnmatch={handleUnmatch}
                backPath={backPath}
            />
        </WrapperPageSimple>
    )
}

export default PageTmdbLinkPage
